"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportItem$ = exports.TransportItem$outboundSchema = exports.TransportItem$inboundSchema = void 0;
exports.transportItemToJSON = transportItemToJSON;
exports.transportItemFromJSON = transportItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
/** @internal */
exports.TransportItem$inboundSchema = z.object({
    atco_code: z.string(),
    distance_in_metres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    stop_name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "atco_code": "atcoCode",
        "distance_in_metres": "distanceInMetres",
        "stop_name": "stopName",
    });
});
/** @internal */
exports.TransportItem$outboundSchema = z.object({
    atcoCode: z.string(),
    distanceInMetres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    stopName: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        atcoCode: "atco_code",
        distanceInMetres: "distance_in_metres",
        stopName: "stop_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TransportItem$;
(function (TransportItem$) {
    /** @deprecated use `TransportItem$inboundSchema` instead. */
    TransportItem$.inboundSchema = exports.TransportItem$inboundSchema;
    /** @deprecated use `TransportItem$outboundSchema` instead. */
    TransportItem$.outboundSchema = exports.TransportItem$outboundSchema;
})(TransportItem$ || (exports.TransportItem$ = TransportItem$ = {}));
function transportItemToJSON(transportItem) {
    return JSON.stringify(exports.TransportItem$outboundSchema.parse(transportItem));
}
function transportItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TransportItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TransportItem' from JSON`);
}
//# sourceMappingURL=transportitem.js.map